package com.eladfinish.bible.contest.features.share

import org.koin.core.module.Module
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val shareModule = module {
    factoryOf(::ShareAppUseCaseCommon)
}


expect val sharePlatformModule: Module
